<template>
  <div>
    <model-select
      v-if="items"
      placeholder="Seleziona il metodo di pagamento..."
      :defaultOptions="items"
      :id="idSelected"
      :canSearch="false"
      :value="null"
      :formClass="formClass"
      :canCreate="false"
      :showTitle="false"
      :classes="classes"
      :disabled="disabled"
      @selected="onItemSelected"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Mixins } from "vue-property-decorator";
import ModelSelect from "components/ModelSelect.vue";
import { RequestData } from "store/types";
import { RegisterHttp } from "utils/Decorators";
import PlaceParametersMixin from "mixins/http/PlaceParametersMixin";
import { PaymentMethod } from "models";
import ObjectPathMixin from "mixins/ObjectPathMixin";

@Component({ components: { ModelSelect } })
export default class PaymentMethodSelect extends Mixins(
  PlaceParametersMixin,
  ObjectPathMixin,
) {
  static readonly getPaymentMethodsTag = "get_payment_methods";
  @RegisterHttp(PaymentMethodSelect.getPaymentMethodsTag) http: RequestData;

  @Prop() idSelected?: string | number;
  @Prop() params;
  @Prop() formClass?: string;
  @Prop() classes?: string;
  @Prop() dataKeys?: string;
  @Prop({ default: false }) disabled?: boolean;

  items: any = null;

  get queryParams() {
    return { per: 1000, ...this.params };
  }

  mounted() {
    this.loadItems();
  }

  outputParams(data) {
    return this.outputObject(data, this.dataKeys);
  }

  onItemSelected(data) {
    this.$emit("change", this.outputParams(data));
  }

  loadItems() {
    this.getPlaceParameters(
      PaymentMethod,
      this.queryParams,
      PaymentMethodSelect.getPaymentMethodsTag,
    ).then((resp) => {
      this.items = resp.filter((element) => element.disabled === false);
    });
  }
}
</script>

<style scoped></style>
